<template>
  <el-dialog
    v-if="visible"
    visible
    show-close
    width="800px"
    :title="title"
    :before-close="() => $refs.main.cancel()"
    append-to-body
    v-el-dialog-drag
  >
    <Main
      ref="main"
      :inspectionAqlCode="inspectionAqlCode"
      :disabled="disabled"
      @reload="$emit('reload')"
      @close="close()"
    />

    <span slot="footer">
      <el-button size="small" @click="$refs.main.cancel()">
        {{ $l('INDEX.btn_cancel') || '取消' }}
      </el-button>
      <el-button
        v-if="!disabled"
        type="primary"
        size="small"
        @click="$refs.main.save()"
      >
        {{ $l('INDEX.btn_save') || '保存' }}
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import Main from './main.vue'
export default {
  components: { Main },
  props: {
    visible: { type: Boolean, default: false },
    type: { type: String, default: '' },
    inspectionAqlCode: { type: String, default: '' },
  },
  computed: {
    titleMap() {
      return {
        edit: this.$l('dialog_title_edit') || '编辑来料检验AQL抽样规则',
        add: this.$l('dialog_title_add') || '新增来料检验AQL抽样规则',
        detail: this.$l('dialog_title_detail') || '来料检验AQL抽样规则详情',
      }
    },
    title() {
      return this.titleMap[this.type]
    },
    disabled() {
      return this.type === 'detail'
    },
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped></style>
